import React, { FC } from 'react';
import AdminContent from '../../components/AdminContent';
import NonEditablePages from './components/NonEditablePages';

export const pageAdminInfo = {
  title: 'Páginas',
  description: 'Personalize configurações gerais das páginas',
  path: 'pages',
};

const CmsPagesPage: FC = () => {
  return (
    <AdminContent
      title={pageAdminInfo.title}
      description={pageAdminInfo.description}
    >
      <NonEditablePages />
    </AdminContent>
  );
};
export default CmsPagesPage;
